import { call, cancel, fork, put, take, takeLatest } from 'redux-saga/effects';
import * as api from 'api/discountRule';
import * as toastActions from 'state/toast/actions';
import * as actions from './actions';
import {
  GET_DISCOUNT_RULES,
  SAVE_DISCOUNT_RULE,
  DELETE_DISCOUNT_RULE,
  DISCOUNT_RULE_DO_SHOW_LOG,
  DISCOUNT_RULE_LOG_CHANGE_PAGE,
  DISCOUNT_RULE_LOG_SET_SHOWN,
} from './actionTypes';

export function* getDiscountRules() {
  try {
    yield put(actions.setDiscountRulesLoading(true));
    const response = yield call(api.getDiscountRulesApi);
    yield put(actions.updateDiscountRules(response.data.data || []));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Error', 'Failed to fetch discount rules')
    );
  } finally {
    yield put(actions.setDiscountRulesLoading(false));
  }
}

export function* saveDiscountRule({ payload }) {
  try {
    yield put(actions.showEditorModalLoading(true));

    if (payload.id) {
      yield call(api.updateDiscountRuleApi, payload);
      yield put(
        toastActions.successMessage('Discount rule updated successfully')
      );
    } else {
      yield call(api.createDiscountRuleApi, payload);
      yield put(
        toastActions.successMessage('Discount rule created successfully')
      );
    }

    yield put(actions.showCreateDiscountRuleModal(false));
    yield put(actions.showEditDiscountRuleModal(false, null));
    yield call(getDiscountRules);
  } catch (error) {
    const data = error.response && error.response.data;
    const errorMessage =
      (data && data.message) || 'Failed to save discount rule';
    const backendErrors = (data && data.errors) || [];
    yield put(actions.setEditorErrorMessage(errorMessage, backendErrors));
  } finally {
    yield put(actions.showEditorModalLoading(false));
  }
}

export function* deleteDiscountRule({ payload }) {
  try {
    yield put(actions.setDiscountRulesLoading(true));
    yield call(api.deleteDiscountRuleApi, payload.id);
    yield put(
      toastActions.successMessage('Discount rule deleted successfully')
    );
    yield call(getDiscountRules);
  } catch (error) {
    yield put(
      toastActions.errorMessage('Error', 'Failed to delete discount rule')
    );
  } finally {
    yield put(actions.setDiscountRulesLoading(false));
  }
}

function* logModalTask() {
  while (true) {
    const { page } = (yield take(DISCOUNT_RULE_LOG_CHANGE_PAGE)).payload;
    yield put(actions.setLogIsLoading(true));
    yield put(actions.clearLogErrors());
    yield put(actions.resetLogData());
    try {
      const {
        data: {
          data: { internal_tools_activities: activities },
          paging,
        },
      } = yield call(api.getDiscountRuleLogs, page, 20);
      yield put(actions.setLogData(activities, paging));
    } catch (e) {
      yield put(actions.setLogErrors(e.message));
    } finally {
      yield put(actions.setLogIsLoading(false));
    }
  }
}

export function* doShowLogs() {
  const task = yield fork(logModalTask);
  yield put(actions.setLogPage(1));
  yield put(actions.setLogModalShown(true));
  let closeModalRequest;
  do {
    closeModalRequest = (yield take(DISCOUNT_RULE_LOG_SET_SHOWN)).payload;
  } while (closeModalRequest.shown);
  yield cancel(task);
}

export default function* saga() {
  yield takeLatest(GET_DISCOUNT_RULES, getDiscountRules);
  yield takeLatest(SAVE_DISCOUNT_RULE, saveDiscountRule);
  yield takeLatest(DELETE_DISCOUNT_RULE, deleteDiscountRule);
  yield takeLatest(DISCOUNT_RULE_DO_SHOW_LOG, doShowLogs);
}
